import React, { useEffect, useState } from "react";
import { getUsuarioByIdRoyal } from "../userService";

export default function MeusDados() {
  const [userData, setUserData] = useState(null);
  const [loadingUser, setLoadingUser] = useState(true);
  const [errorUser, setErrorUser] = useState("");

  useEffect(() => {
    async function loadUser() {
      try {
        setLoadingUser(true);
        setErrorUser("");

        const usuarioStorage = JSON.parse(localStorage.getItem("usuario") || "{}");
        const usuario_id = Number(usuarioStorage?.usuario_id) || 0;

        if (!usuario_id) {
          setErrorUser("usuario_id não encontrado");
          setUserData(null);
          return;
        }

        const response = await getUsuarioByIdRoyal(usuario_id);
        const usuarioApi = response?.data?.usuario || null;

        setUserData(usuarioApi);
      } catch (error) {
        setErrorUser(error.message || "Erro ao buscar usuário");
        setUserData(null);
      } finally {
        setLoadingUser(false);
      }
    }

    loadUser();
  }, []);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "16px",
        width: "100%",
      }}
    >
      <h2
        style={{
          margin: 0,
          fontSize: "22px",
          fontWeight: 600,
        }}
      >
        Meus dados
      </h2>

      {loadingUser && <p style={{ margin: 0 }}>Carregando...</p>}

      {!loadingUser && errorUser && (
        <p style={{ margin: 0, color: "#b91c1c" }}>{errorUser}</p>
      )}

      {!loadingUser && !errorUser && userData && (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "12px",
            border: "1px solid #e6e9ee",
            borderRadius: "12px",
            padding: "16px",
            backgroundColor: "#fff",
          }}
        >
          <div>
            <p style={{ margin: "0 0 4px 0", fontSize: "12px", color: "#6b7280" }}>
              Nome
            </p>
            <p style={{ margin: 0, fontSize: "16px", fontWeight: 500 }}>
              {userData.usuario_nome || "-"}
            </p>
          </div>

          <div>
            <p style={{ margin: "0 0 4px 0", fontSize: "12px", color: "#6b7280" }}>
              Email
            </p>
            <p style={{ margin: 0, fontSize: "16px", fontWeight: 500 }}>
              {userData.usuario_email || "-"}
            </p>
          </div>

          <div>
            <p style={{ margin: "0 0 4px 0", fontSize: "12px", color: "#6b7280" }}>
              Celular
            </p>
            <p style={{ margin: 0, fontSize: "16px", fontWeight: 500 }}>
              {userData.usuario_celular || "-"}
            </p>
          </div>
        </div>
      )}
    </div>
  );
}